import { QueryTuple, useLazyQuery } from '@apollo/client';
import { GET_PROJECT_COMMODITY_TYPES_BY_ID } from '@bechtel/client-gql';
import { Project } from '@bechtel/types';

export function useProjectCommodityTypesById(
  fetchFromNetwork?: boolean
): QueryTuple<{ projectsByIds: Project[] }, { ids: string }> {
  const response = useLazyQuery<
    {
      projectsByIds: Project[];
    },
    { ids: string }
  >(
    GET_PROJECT_COMMODITY_TYPES_BY_ID,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
